// extracted by mini-css-extract-plugin
module.exports = {"headerControlsSave":"HasChanges_headerControlsSave__1nniV","timeText":"HasChanges_timeText__3vI3L","timeTextButton":"HasChanges_timeTextButton__A2gsS"};